import React, { forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import StoreIcon from '@mui/icons-material/Store';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FastfoodIcon from '@mui/icons-material/Fastfood';
// import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
// import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import CategoryIcon from '@mui/icons-material/Category';
// import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import PaymentIcon from '@mui/icons-material/Payment';
// import SoupKitchenIcon from '@mui/icons-material/SoupKitchen';
import {ListItemButton} from "@mui/material";

const useStyles = makeStyles({
    list: {
        width: 200,
    },
    fullList: {
        width: 'auto',
    },
    icon: {
        minWidth: '35px'
    }
});

const SideMenu = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [role] = React.useState(props.role);

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setOpen(open);
    };

    useImperativeHandle(ref, () => ({
        toggleDrawer(open) {
            setOpen(open);
        }

    }));

    const list = () => (
        <div
            className={classes.list}
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}>
            <List>
                <ListItemButton component={Link} to="/home">
                    <ListItemIcon sx={{minWidth: '35px'}}><DashboardIcon/></ListItemIcon>
                    <ListItemText primary={t('dashboard.title')}/>
                </ListItemButton>
                <ListItemButton component={Link} to="/shop">
                    <ListItemIcon sx={{minWidth: '35px'}}><StoreIcon/></ListItemIcon>
                    <ListItemText primary={t('shop.title')}/>
                </ListItemButton>
                <ListItemButton component={Link} to="/products">
                    <ListItemIcon sx={{minWidth: '35px'}}><FastfoodIcon/></ListItemIcon>
                    <ListItemText primary={t('product.title')}/>
                </ListItemButton>
                <ListItemButton component={Link} to="/categories">
                    <ListItemIcon sx={{minWidth: '35px'}}><CategoryIcon/></ListItemIcon>
                    <ListItemText primary={t('productCategory.title')}/>
                </ListItemButton>
                {/*<ListItemButton component={Link} to="/kitchens">*/}
                {/*    <ListItemIcon sx={{minWidth: '35px'}}><SoupKitchenIcon/></ListItemIcon>*/}
                {/*    <ListItemText primary={t('kitchen.title')}/>*/}
                {/*</ListItemButton>*/}
                {/*<ListItemButton component={Link} to="/tables">*/}
                {/*    <ListItemIcon sx={{minWidth: '35px'}}><TableRestaurantIcon/></ListItemIcon>*/}
                {/*    <ListItemText primary={t('table.title')}/>*/}
                {/*</ListItemButton>*/}
                {/*<ListItemButton component={Link} to="/deliver">*/}
                {/*    <ListItemIcon sx={{minWidth: '35px'}}><DeliveryDiningIcon/></ListItemIcon>*/}
                {/*    <ListItemText primary={t('deliver.method')}/>*/}
                {/*</ListItemButton>*/}
                <ListItemButton component={Link} to="/payments">
                    <ListItemIcon sx={{minWidth: '35px'}}><PaymentIcon/></ListItemIcon>
                    <ListItemText primary={t('payment.title')}/>
                </ListItemButton>
                <ListItemButton component={Link} to="/lineoa">
                    <ListItemIcon sx={{minWidth: '35px'}}><img alt="LINE" style={{width: '21px', height: '21px'}} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAAAAAA77wXdAAAACXBIWXMAAOw4AADsOAFxK8o4AAAAB3RJTUUH5QcLAigWRXG0FQAAA0xJREFUOMuNle9vU1UYxz/33NP1x2xL143OjS4jNg4HssDIoqluxEiCoBm8MCG+Mfp3zSw6nSEaA8ZfU6nKHC6gmAyztWODscFGYQ1lk7bX9t7ji/5Y27sWzpt7c+4nz/k+5/ne59EUQD6ZzigaLc2153kHgAQK8emlrEXjpbkj0YMSNEVu6lKOpy3n8VNuNGV+873F05d486wuWIg9C4t1eQ6Zn87WyGsJBtqkjll49Gjzv+qkc78fksmlamXhvpdCHqkByszcT8RXjZ2PK0mZ3gns7HvtgKtyhPT5XjyRuDJfwbNpmakoDp8caKkT6hron/thtSTGysqyLDF4pmOXvByD+y9cM0u0LG3qw6Oe3a+h7b3WX4u0JkoKo2c9jS7NNTqslU4vPg6MuhpfsevtQ9Ww97S3WUG8p3xV8NFI8/LtH6LsOjxDAla3+gUU4v5wPtHWRT4e7MrdeKKp9n6BOHolU44c7oHCxYkUcG/sW7U+9vlj1j+KsfbJ5GeTXzwGwuFK5JATlGEYgGHklFFITL1rGAaFQuSYtdcHOF9IlOGgTeRMpJhxx6By6QCBSmR/Hap6t78eEYC4vqDCH3iBFk2VNJv13u19J/VjAcC9t6NNB7BUOXKqFBBVKhVDd34BMF8+Z0kdwKjISFkCtNwFj/56kVby5N2bgFicsLrfcIK1VoHvbvsRweV5tK7D7e2iNegncGY8gMef2lQbrzph6zaANjtuob//CmwlFXq384HHaz3wtmI9fK7VWs+AL6TB1XET8aEEMGcH3PiK9Q+B6ARECMS+Ugr/Tps73li82twbf9ysMlJh6lYzdvEnq9rPm+fXG7MbX6ZrzM/tidVGbHJyhVqY5bE/C7vH/TRRfpWVzfsfx0e6hY1dPr+CHca4PHfsSI+z1iV/fZViNxjSP8/09O0LtHvKFnlyKZahAQzZREJ3dpwo/nKsXfynusMqqdWLNDN3Zo44AOPad5u1LVp6hL09OzRQ96au52tZt/S7t21wULI9G0vV7br9sjPyt32AZOKxJduBvZ3SEV2wjZ/Z+Y28vYlFHYKDx22VSK/aWTE8gER/S/32DKNt5LSOpsC8Mb3SdGgKd2/0cHFoFsdxE1q494QcAP8D2aMrDSp/ZUgAAAAASUVORK5CYII=" /></ListItemIcon>
                    <ListItemText primary={t('lineOA.title')}/>
                </ListItemButton>
                {/*<ListItemButton component={Link} to="/delivery/partners">*/}
                {/*    <ListItemIcon sx={{minWidth: '35px'}}><DeliveryDiningIcon/></ListItemIcon>*/}
                {/*    <ListItemText primary={t('deliveryPartner.title')}/>*/}
                {/*</ListItemButton>*/}
                {/*<ListItemButton component={Link} to="/qrcode">*/}
                {/*    <ListItemIcon sx={{minWidth: '35px'}}><SmartphoneIcon/></ListItemIcon>*/}
                {/*    <ListItemText primary={t('qr.mobile')}/>*/}
                {/*</ListItemButton>*/}
                {/*<ListItemButton component={Link} to="/mobile/deliver">*/}
                {/*    <ListItemIcon sx={{minWidth: '35px'}}><PhoneAndroidIcon/></ListItemIcon>*/}
                {/*    <ListItemText primary={t('mobileOrdering.title')}/>*/}
                {/*</ListItemButton>*/}
                {/*<ListItemButton component={Link} to="/discounts">*/}
                {/*    <ListItemIcon sx={{minWidth: '35px'}}><LocalOfferIcon/></ListItemIcon>*/}
                {/*    <ListItemText primary={t('discount.title')}/>*/}
                {/*</ListItemButton>*/}
                {/*<ListItemButton component={Link} to="/campaigns">*/}
                {/*    <ListItemIcon sx={{minWidth: '35px'}}><CampaignIcon/></ListItemIcon>*/}
                {/*    <ListItemText primary={t('campaigns.title')}/>*/}
                {/*</ListItemButton>*/}
                {/*<ListItemButton component={Link} to="/rewards">*/}
                {/*    <ListItemIcon sx={{minWidth: '35px'}}><CardMembershipIcon/></ListItemIcon>*/}
                {/*    <ListItemText primary={t('reward.title')}/>*/}
                {/*</ListItemButton>*/}
                {/*<ListItemButton component={Link} to="/customers">*/}
                {/*    <ListItemIcon sx={{minWidth: '35px'}}><FaceIcon /></ListItemIcon>*/}
                {/*    <ListItemText primary={t('customer.title')} />*/}
                {/*</ListItemButton>*/}
                {/*<ListItemButton component={Link} to="/users">*/}
                {/*    <ListItemIcon sx={{minWidth: '35px'}}><SupervisorAccountIcon/></ListItemIcon>*/}
                {/*    <ListItemText primary={t('user.title')}/>*/}
                {/*</ListItemButton>*/}
                {/*<ListItemButton component={Link} to="/partners">*/}
                {/*    <ListItemIcon sx={{minWidth: '35px'}}><HandshakeIcon/></ListItemIcon>*/}
                {/*    <ListItemText primary={t('partner.title')}/>*/}
                {/*</ListItemButton>*/}
                {/*<ListItemButton component={Link} to="/market">*/}
                {/*    <ListItemIcon sx={{minWidth: '35px'}}><ShopIcon /></ListItemIcon>*/}
                {/*    <ListItemText primary={t('market.title')} />*/}
                {/*</ListItemButton>*/}
                {/*<ListItemButton component={Link} to="/plugins">*/}
                {/*    <ListItemIcon sx={{minWidth: '35px'}}><ShopIcon/></ListItemIcon>*/}
                {/*    <ListItemText primary={t('plugin.title')}/>*/}
                {/*</ListItemButton>*/}
            </List>
        </div>
    );

    return (
        <div>
            {['OWNER', 'ADMIN'].indexOf(role) > -1 &&
                <Drawer anchor='left' open={open} onClose={toggleDrawer(false)}>
                    {list()}
                </Drawer>
            }
        </div>
    )
});

export default SideMenu;